import { View } from "react-native";
import { useTheme } from "~/styles/theme";

/** A single hairline rule — the Swiss grid's only decoration. */
export function RuleLine({
  strong = false,
  vertical = false,
}: {
  strong?: boolean;
  vertical?: boolean;
}) {
  const { colors } = useTheme();
  const color = strong ? colors.ruleStrong : colors.rule;
  return (
    <View
      style={
        vertical
          ? { width: 1, alignSelf: "stretch", backgroundColor: color }
          : { height: 1, backgroundColor: color }
      }
    />
  );
}
